/* 🤖 this file was generated by svg-to-ts */
export const matIconCropFree: {
  name: 'crop-free';
  data: string;
} = {
  name: 'crop-free',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"/></svg>`
};
